/* Layout types and other constants */

export const LAYOUT_VERTICAL = 'vertical';
export const LAYOUT_WIDTH_FLUID = 'fluid';
export const LEFT_SIDEBAR_THEME_DARK = 'default';
export const LEFT_SIDEBAR_TYPE_FIXED = 'fixed';
